export enum RewardTriggerEvent {
	CustomerCreation = "customer_creation",
	Checkout = "checkout",
}

export enum RewardReceivedBy {
	Referrer = "referrer",
	All = "all",
}
